__webpack_require__.p = "/addschool/";